/**
 * Closed-beta API service.
 *
 * The claim endpoint's real output is a Set-Cookie header, not its JSON body:
 * it stashes a validated credential that the sign-up gate reads server-side.
 * apiFetch already sends credentials: "include", so the cookie is stored
 * first-party via the same-origin /api/backend rewrite.
 */

import { apiFetch } from "./client";

export type BetaClaimKind = "code" | "household";

export interface BetaClaimResult {
  valid: true;
  kind: BetaClaimKind;
}

export interface BetaStatus {
  required: boolean;
}

/** Whether registration currently requires an invite. */
export async function getBetaStatus(): Promise<BetaStatus> {
  return apiFetch<BetaStatus>("/beta/status");
}

/** Validate an invite and stash it for the upcoming registration. */
export async function claimBetaInvite(input: {
  type: BetaClaimKind;
  value: string;
}): Promise<BetaClaimResult> {
  return apiFetch<BetaClaimResult>("/beta/claim", {
    method: "POST",
    body: JSON.stringify(input),
  });
}
